import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';


//Action Creators
export const loadProjectTypeListStart = () => {
  return {type: actionTypes.PROJECTTYPELIST_LOAD_START};
};
export const loadProjectTypeListFail = (error) => {
  console.error(error);
  return {type: actionTypes.PROJECTTYPELIST_LOAD_FAIL, error};
};
export const loadProjectTypeListSuccess = (data) => {
  return {type: actionTypes.PROJECTTYPELIST_LOAD_SUCCESS, payload: data};
};
export const setProjectTypeListType = (selectedProjectTypes) => {
  return {
    type: actionTypes.PROJECTTYPELIST_SET,
    selectedProjectTypes,
  };
};


export const initProjectTypeList = (id, defaultValue, cmsName) => dispatch => {
  dispatch(loadProjectTypeListStart());

  const loadNav =
    cmsName
      ? apiActions
          .loadEndpointByFilters(apiValues.nref.mListNav.endpoint, {
            'filters[cmsName][$eq]': cmsName,
            'pagination[limit]': 1,
          })
          .then((results) => (Array.isArray(results) ? results[0] : results))
      : apiActions.loadEndpoint(apiValues.nref.mListNav.endpoint, id);

  loadNav.then((result) => {
    if (!result) {
      return Promise.reject(new Error(`m-list-nav not found: ${cmsName || id}`));
    }
    let n = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.mListNav.fieldsUsed);
    let types = (n.projectTypes || []).map(projectType => {
      return apiActions.itemSelectCamelCaseKeys(projectType, apiValues.nref.projectType.fieldsUsed);
    });

    if(defaultValue) dispatch(setProjectTypeListType(defaultValue));

    dispatch(loadProjectTypeListSuccess(types));
  }).catch((error) => dispatch(loadProjectTypeListFail(error)));
};
export const filterList = (selectedProjectTypes) => dispatch => {
  // console.log(selectedProjectTypes);
  dispatch(setProjectTypeListType(selectedProjectTypes));
};
